import Vue from 'vue'
import ApiBase from '@/api/apiBase'

class ApiNotifications {

    static loadFilters(callBack, errorCallBack) {
        ApiBase.get(`/notifications/filters`, callBack, ApiBase.noParse, errorCallBack)
    }

    static sendNotifications(teamsids,msg,onlyAdmins,callBack, errorCallBack) {
      let data = {
        "msg": msg,
        "teams": teamsids,
        "onlyAdmins": onlyAdmins
      }
        ApiBase.post(`/notifications/send`,data, callBack, ApiBase.noParse, errorCallBack)
    }

}

export default ApiNotifications



// WEBPACK FOOTER //
// ./src/api/apiNotifications.js